(function() {
'use strict';

const TR = angular.module('TR');
TR.directive('urgencyMessages', function(urgencyMessaging, arrayUtil, $interval, $timeout) {
    return {
        restrict: 'E',
        scope: {
            estabId: '='
        },
        template: '<p class="hotel-urgency-message"></p>',
        link(scope, el) {
            const fade = 500;
            const cycle = 5000;
            const p = el.find('p:first');
            let msgs;
            let i = 0;
            let loop;

            function showMsg() {
                i += 1;
                p.addClass('faded');
                $timeout(function() {
                    p.text(msgs[i % msgs.length]);
                    p.removeClass('faded');
                }, fade);
            }

            urgencyMessaging.get(scope.estabId).then(function(stats) {
                if (stats != null) {
                    msgs = arrayUtil.filter([stats.CurrentViewsText, stats.LastBookedDateText, stats.ShortlistCountText], function(msg) {
                        return msg != null;
                    });
                    if (msgs.length > 0) {
                        p.text(msgs[i]);
                        if (msgs.length > 1) {
                            loop = $interval(showMsg, cycle);
                        }
                    }
                }
            });

            scope.$on('$destroy', function() {
                $interval.cancel(loop);
            });
        }
    };
});
})();
